import { PassportSerializer } from '@nestjs/passport';
import { Injectable } from '@nestjs/common';
import { AuthService } from './auth.service';
import { CreateUserDto } from '@gtpl/shared-models/gtpl';
import { AuthenticationProvider } from './auth';
import { UserEntity } from '../user/user.entity';

@Injectable()
export class SessionSerializer extends PassportSerializer {
constructor(
    private readonly userService:AuthService
) {
    super()
}

  serializeUser(user: UserEntity, done: (err: Error, user: any) => void): any {
    done(null, user);
  }

  async deserializeUser(user: UserEntity, done: (err: Error, user: number) => void) {
      const userDB = await this.userService.findUser(user.employeeId)
    return userDB? done(null, userDB.id): done(null,null)
  }
}